import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader 
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOABanking() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ banking, setBanking ] = useState(powerOfAttorney.banking_transactions || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../powers-intro');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      banking_transactions: banking
    }));
    navigate('../securities');
  }, [ banking, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-banking screen-container screen">
      <ScreenHeader
        title="Banking Transactions"
        description="Decide whether to grant your agent power over your bank accounts"
        handleBack={handleBack}
      />
      
      <div className="content-section poa-section">
        <h3>What Are Banking Powers?</h3>
        <p>
          Banking powers allow your agent to manage your financial accounts, including:
        </p>
        <ul className="banking-list">
          <li>Checking and savings accounts</li>
          <li>Money market accounts</li>
          <li>Certificates of deposit (CDs)</li>
          <li>Safe deposit boxes</li>
          <li>Online banking access</li>
          <li>Account transfers and payments</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Deposit and withdraw funds</li>
          <li>Write checks and make payments</li>
          <li>Transfer money between accounts</li>
          <li>Access online banking</li>
          <li>Order checks and debit cards</li>
          <li>Close or open accounts</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="banking-yes"
            label="Yes"
            description="Grant power over banking transactions"
            value="yes"
          />
          <AssetDistributionOption
            id="banking-no"
            label="No"
            description="Do not grant power over banking transactions"
            value="no"
          />  
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
